import React from "react"
import Skeleton from "@components/Skeleton/Skeleton"
import { LabsHeroWidgetConfig } from "@widgets/vsat/LabsHeroWidget/LabsHeroWidget.skeleton"
import { LabsMasterWidgetConfig } from "@widgets/vsat/LabsMasterWidget/LabsMasterWidget.skeleton"
import { HorizontalPackageListing } from "@widgets/vsat/HorizontalPackageListing/HorizontalPackageListing.skeleton"
import { AppDownloadNudgeConfig } from "@widgets/v2/AppDownloadNudge/AppDownloadNudge.skeleton.js"
import { fixedBannerConfig } from "@widgets/vsat/FixedBannerWidget/FixedBannerWidget.skeleton"
import { BannerWidgetCarouselAutoScrollConfig } from "@widgets/vsat/BannerWidgetCarouselAutoScroll/BannerWidgetCarouselAutoScroll.skeleton"
import { ProcessCarouselConfig } from "@widgets/vsat/ProcessCarousel/ProcessCarousel.skeleton"
import { LabsFeaturesConfig } from "@widgets/vsat/LabsFeatures/LabsFeatures.skeleton"
function LabsHomePageSkeleton() {
    return (
        <div className="flexColumn">
            {/* Simple skeleton for testing */}
            <div className="widget-container mBottom-8" style={{ marginTop: "56px" }}>
                <Skeleton config={LabsHeroWidgetConfig} isComponent />
            </div>

            {/* Labs Master Widget */}
            <div className="widget-container marginBoth-8">
                <Skeleton config={LabsMasterWidgetConfig} isComponent />
            </div>

            <div className="widget-container marginBoth-8">
                <Skeleton config={fixedBannerConfig} isComponent />
            </div>

            <div className="widget-container marginBoth-8">
                <Skeleton config={HorizontalPackageListing} isComponent />
            </div>

            <div className="widget-container marginBoth-8">
                <Skeleton config={BannerWidgetCarouselAutoScrollConfig} isComponent />
            </div>

            <div className="widget-container marginBoth-8">
                <Skeleton config={ProcessCarouselConfig} isComponent />
            </div>
            <div className="widget-container marginBoth-8">
                <Skeleton config={AppDownloadNudgeConfig} isComponent />
            </div>

            <div className="widget-container marginBoth-8">
                <Skeleton config={LabsFeaturesConfig} isComponent />
            </div>
        </div>
    )
}

export default LabsHomePageSkeleton
